import { ThemeProvider } from "@mui/material";

import { RootState } from "@app/store";
import { useTheme } from "next-themes";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import darkTheme from "./darkTheme";
import lightTheme from "./lightTheme";

export const NextThemeConfigProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const { lightPalette, darkPalette } = useSelector(
    (state: RootState) => state.colorPalette
  );
  const [userPalette, setUserPalette] = useState<Palette>(lightPalette);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const theme = useMemo(
    () =>
      resolvedTheme === "light"
        ? lightTheme(userPalette)
        : darkTheme(userPalette),
    [resolvedTheme, userPalette]
  );

  React.useEffect(() => {
    if (resolvedTheme === "light") {
      setUserPalette(lightPalette);
    } else {
      setUserPalette(darkPalette);
    }
  }, [resolvedTheme, lightPalette, darkPalette]);
  if (!mounted) return <div style={{ visibility: "hidden" }} />;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
